<template>
    <button
        type="button"
        class="mvt-toggle-switch"
        :class="{ 'mvt-toggle-switch--on': modelValue }"
        role="switch"
        :aria-checked="modelValue"
        :aria-label="ariaLabel || undefined"
        :disabled="disabled"
        @click.stop="onClick"
    >
        <span class="mvt-toggle-switch__track" aria-hidden="true">
            <span class="mvt-toggle-switch__knob"></span>
        </span>
    </button>
</template>

<script>
export default {
    name: 'mvtToggleSwitch',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        /** Accessible name when no visible label */
        ariaLabel: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue', 'click'],
    methods: {
        onClick(e) {
            if (this.disabled) return;
            this.$emit('click', e);
            this.$emit('update:modelValue', !this.modelValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.mvt-toggle-switch {
    --mvt-switch-track-off: #808491;
    --mvt-switch-track-on: #0066ff;
    --mvt-switch-knob: #fff;

    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    vertical-align: middle;

    &__track {
        box-sizing: border-box;
        width: 44px;
        height: 24px;
        padding: 2px;
        border-radius: 12px;
        background-color: var(--mvt-switch-track-off);
        display: block;
        transition: background-color 0.2s ease;
    }

    &__knob {
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: var(--mvt-switch-knob);
        transform: translateX(0);
        transition: transform 0.2s ease;
    }

    &--on .mvt-toggle-switch__track {
        background-color: var(--mvt-switch-track-on);
    }

    &--on .mvt-toggle-switch__knob {
        transform: translateX(20px);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }

    &:focus-visible {
        outline: 2px solid var(--mvt-switch-track-on, #0066ff);
        outline-offset: 2px;
    }
}
</style>
